// extracted by mini-css-extract-plugin
export default {"container":"l_-z","tab":"m_-z","selected":"n_-z"};